import React, { useState } from 'react';
import styles from '../../../styles/common/common-styles.module.scss';
import Button from '../button/Button';
import RadioButtonList from '../radioButtonList/RadioButtonList';
import { regexByPhoneNumber, regexByEmail } from '../../../utils/RegexHelper';
import ErrorMsg from '../error/ErrorMsg';

const Question4 = props => {
  const [phoneHasError, setPhoneHasError] = useState(false);
  const [emailHasError, setEmailHasError] = useState(false);

  return (
    <div className={`row ${styles.questionWrap}`}>
      <div className={`col`}>
        <h3 className={`${styles.pageTitle}`}>
          Do you have the details of a person with an official role?
        </h3>
        <p className={styles.questionText}>
          Organisations will also contact this person to manage the accounts.
        </p>
        <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
          <RadioButtonList
            list={[
              {
                value: '2',
                label: 'Yes',
                checked:
                  props.officialPersonDetailsAvailable &&
                  props.officialPersonDetailsAvailable.value === '2'
                    ? true
                    : false,
              },
              {
                value: '1',
                label: 'No',
                checked:
                  props.officialPersonDetailsAvailable &&
                  props.officialPersonDetailsAvailable.value === '1'
                    ? true
                    : false,
              },
            ]}
            id={'officialPersonDetailsAvailable'}
            name={'officialPersonDetailsAvailable'}
            displayLayout={'horizontal'}
            className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
            handleChange={(item, name) => {
              props.setofficialPersonDetailsAvailable(item);
              if (item?.value === '1') {
                props.setOfficialRoleFirstName(null);
                props.setOfficialRoleLastName(null);
                props.setOfficialRoleContactNumber(null);
                props.setOfficialRoleEmailAddress(null);
                props.setOfficialRoleType(null);
              }
            }}
          />
        </fieldset>

        {props.officialPersonDetailsAvailable?.value === '2' ? (
          <div className={`mt-5`}>
            <h3 className={`${styles.pageTitle}`}>Person with an official role</h3>
            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <label
                for={`officialRoleFirstName`}
                className={`nsw-form-label ${styles.nswFormLabel}`}
              >
                Given name
              </label>
              <input
                id={'officialRoleFirstName'}
                name={'officialRoleFirstName'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                value={
                  props.officialRoleFirstName && props.officialRoleFirstName.length > 0
                    ? props.officialRoleFirstName
                    : undefined
                }
                onChange={event => {
                  props.setOfficialRoleFirstName(event.target.value);
                }}
              />
            </div>
            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <label
                for={`officialRoleLastName`}
                className={`nsw-form-label ${styles.nswFormLabel}`}
              >
                Last name
              </label>
              <input
                id={'officialRoleLastName'}
                name={'officialRoleLastName'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                value={
                  props.officialRoleLastName && props.officialRoleLastName.length > 0
                    ? props.officialRoleLastName
                    : undefined
                }
                onChange={event => {
                  props.setOfficialRoleLastName(event.target.value);
                }}
              />
            </div>
            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <label
                for={`officialRoleContactNumber`}
                className={`nsw-form-label ${styles.nswFormLabel}`}
              >
                Contact number
              </label>
              <input
                type="text"
                inputmode="decimal"
                id={'officialRoleContactNumber'}
                name={'officialRoleContactNumber'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                maxLength={'20'}
                value={
                  props.officialRoleContactNumber && props.officialRoleContactNumber.length > 0
                    ? props.officialRoleContactNumber
                    : undefined
                }
                onChange={event => {
                  setPhoneHasError(regexByPhoneNumber(event.target.value));
                  props.setOfficialRoleContactNumber(event.target.value);
                }}
                aria-describedby={phoneHasError ? 'notifiersContactNumberErrorMessage' : undefined}
                aria-invalid={`${phoneHasError ? 'true' : 'false'}`}
              />
            </div>
            {phoneHasError ? (
              <div className={`row`}>
                <div className={`col-12 ${styles.errorContainer1}`}>
                  <ErrorMsg
                    id={'officialRoleContactNumberErrorMessage'}
                    type={'error'}
                    description={'The contact number is invalid.'}
                  />
                </div>
              </div>
            ) : null}

            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <h4 className={styles.nswFormLabel}>Email address</h4>
              <input
                id={'officialRoleEmailAddress'}
                name={'officialRoleEmailAddress'}
                className={`nsw-form-input ${styles.nswFormInput}`}
                value={
                  props.officialRoleEmailAddress && props.officialRoleEmailAddress.length > 0
                    ? props.officialRoleEmailAddress
                    : undefined
                }
                onChange={event => {
                  setEmailHasError(regexByEmail(event.target.value));
                  props.setOfficialRoleEmailAddress(event.target.value);
                }}
                aria-describedby={
                  emailHasError ? 'officialRoleEmailAddressErrorMessage' : undefined
                }
                aria-invalid={`${emailHasError ? 'true' : 'false'}`}
              />
            </div>
            {emailHasError ? (
              <div className={`row`}>
                <div className={`col-12 ${styles.errorContainer1}`}>
                  <ErrorMsg
                    id={'officialRoleEmailAddressErrorMessage'}
                    type={'error'}
                    description={'The email address is invalid.'}
                  />
                </div>
              </div>
            ) : null}

            <div className={`col-lg-7 col-md-10 row ${styles.mobileRow}`}>
              <h4 className={styles.nswFormLabel}>Role type</h4>
              <div className={`w-100`}>
                <fieldset className={`nsw-form-fieldset ${styles.nswFormFieldset}`}>
                  <RadioButtonList
                    list={[
                      {
                        value: '2',
                        label: 'Executor',
                        checked:
                          props.officialRoleType && props.officialRoleType.value === '2'
                            ? true
                            : false,
                      },
                      {
                        value: '1',
                        label: 'Administrator',
                        checked:
                          props.officialRoleType && props.officialRoleType.value === '1'
                            ? true
                            : false,
                      },
                      {
                        value: '3',
                        label: 'Solicitor',
                        checked:
                          props.officialRoleType && props.officialRoleType.value === '3'
                            ? true
                            : false,
                      },
                    ]}
                    id={'officialRoleType'}
                    name={'officialRoleType'}
                    displayLayout={'horizontal'}
                    className={`nsw-form-radio__input ${styles.nswFormRadio__input}`}
                    handleChange={(item, name) => {
                      props.setOfficialRoleType(item);
                    }}
                  />
                </fieldset>
              </div>
            </div>
          </div>
        ) : null}

        <div className={styles.btnWrap}>
          <Button
            disabled={
              !props.officialPersonDetailsAvailable ||
              (props.officialPersonDetailsAvailable?.value === '2' &&
                (!props.officialRoleFirstName ||
                  !props.officialRoleLastName ||
                  !props.officialRoleContactNumber ||
                  !props.officialRoleEmailAddress ||
                  !props.officialRoleType?.value ||
                  emailHasError ||
                  phoneHasError))
            }
            onClick={() => {
              props.saveContactDetails();
            }}
          >
            Next
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Question4;
